import {
  languageTagForUiLocale,
  type UiLocale,
} from "./locale";

export function formatLocaleNumber(
  locale: UiLocale,
  value: number,
  options?: Intl.NumberFormatOptions,
): string {
  return new Intl.NumberFormat(
    languageTagForUiLocale(locale),
    options,
  ).format(value);
}

export function formatLocaleCurrency(
  locale: UiLocale,
  value: number,
  currency: string,
  options?: Omit<
    Intl.NumberFormatOptions,
    "style" | "currency"
  >,
): string {
  return new Intl.NumberFormat(languageTagForUiLocale(locale), {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 0,
    ...options,
  }).format(value);
}

export function formatLocalePercent(
  locale: UiLocale,
  percentagePoints: number,
  fractionDigits = 2,
  signDisplay: Intl.NumberFormatOptions["signDisplay"] = "auto",
): string {
  return new Intl.NumberFormat(languageTagForUiLocale(locale), {
    style: "percent",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    signDisplay,
  }).format(percentagePoints / 100);
}

export function formatLocaleDate(
  locale: UiLocale,
  value: Date | number,
  options?: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(
    languageTagForUiLocale(locale),
    options,
  ).format(value);
}
